export const iterateOverShapesMap = (map, cb) => {
    for (const netUid of Object.keys(map)) {
        for (const layoutUid of Object.keys(map[netUid] ?? {})) {
            for (const layerId of Object.keys(map[netUid]?.[layoutUid] ?? {})) {
                const shape = map[netUid]?.[layoutUid]?.[layerId];
                // QUESTION: how can shape be undefined? Something weird happening here.
                if (shape) {
                    cb(shape, [netUid, layoutUid, layerId]);
                }
            }
        }
    }
};
//# sourceMappingURL=ShapesMap.js.map